import {Component, OnInit} from '@angular/core';
import {AuthService} from 'src/app/services/auth.service';
import {hasPermission, User} from 'src/app/model/user';
import {Company} from 'src/app/model/company';
import {UsersService} from 'src/app/services/users.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'aw-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  loggedUser: User = this.authService.loggedUser();
  company?: Company;
  notifications: any[] = [];

  constructor(
    private authService: AuthService,
    private snackbar: MatSnackBar,
    private usersService: UsersService
  ) {
    if (hasPermission(this.loggedUser, 'customer'))
      this.company = (this.authService.loggedUser() as User)?.company;
  }


  ngOnInit(): void {
    // TODO REMOVED - REWORK NEEDED ON THE COMPONENT
    //   this.usersService.getNotificationPreferences(this.loggedUser.id).subscribe(response => {
    //     const res = response as any;
    //     this.notifications = res.data;
    //   });
    //
  }

  //
  // updateNotificationsOption(type: number, channel: number): void {
  //   this.notifications[type].channels[channel].enabled = !this.notifications[type].channels[channel].enabled;
  // }
  //
  // saveNotificationsSettings(): void {
  //   this.usersService.markNotificationPreferences(this.loggedUser.id, this.notifications).subscribe(() => {
  //       this.snackbar.open('Notification preferences saved successfully', 'Undo', {
  //         duration: 2000
  //       });
  //     },
  //     () => {
  //       this.snackbar.open('Notification preferences not saved successfully', 'Undo', {
  //         duration: 2000
  //       });
  //
  //     });
  //
  // }

}
